export default {
      id: "notifications__low-battery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__low-battery",
      toString: function () {
        return this.url;
      }
    }